import React from "react";
import { Header } from "../../components";
import { HomeContainer } from "../../containers";
import { withAppLayout } from "../../hoc";
import { Col } from "react-bootstrap";
import { ROUTES } from "../../utils";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const Home = (props) => {
  return (
    <Col className="app-outer-layout" style={{ height: "100vh" }}>
      <Redirect to={ROUTES.PAYROLL} />
      <HomeContainer {...props} />
    </Col>
  );
};

export default withAppLayout(Home);
